export default {
  namespaced: true,
  operational_procedure: {
    title: "Procedimento Operacional",
    simulacrums_title: "Procedimento Operacional",
    new: "Novo Procedimento Operacional",
    reference_number: "Número de referência",
    select_form: "Selecionar formulário(s)",
    select_form_place_holder: "Selecione um formulário",
    selected_form: "Formulário selecionado",
    answer_form: "Iniciar formulário",
    confirm_delete: "Tem certeza de que deseja excluir este simulacro?",
    no_records: "Nenhum procedimento operacional encontrado",
    reassign: "Reatribuir",
    template: {
      title: "Modelos de formulário",
    },
    confirm_cancel: "Tem certeza de que deseja cancelar este procedimento operacional?",
    canceled: "Procedimento operacional cancelado",
    reassigned: "Reatribuído",
  },
  operational_procedure_exercise: {
    title: "Exercício Operacional",
    new: "Novo Exercício Operacional",
    template: {
      title: "Modelos de formulário",
    },
  },
};
